<section class="w-full">
    <app-landing-type01></app-landing-type01>
</section>